import { BaseClient } from '../client';

export const deleteBuyer = async ({ id }: { id: string }) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 'Apagado com sucesso';
	// }

	try {
		const response = await BaseClient.delete<string>(`/Admin/DeleteAdminRevenda/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
